import { render, staticRenderFns } from "./noticeList.vue?vue&type=template&id=7675414e&scoped=true&"
import script from "./noticeList.vue?vue&type=script&lang=js&"
export * from "./noticeList.vue?vue&type=script&lang=js&"
import style0 from "./noticeList.vue?vue&type=style&index=0&id=7675414e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7675414e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7675414e')) {
      api.createRecord('7675414e', component.options)
    } else {
      api.reload('7675414e', component.options)
    }
    module.hot.accept("./noticeList.vue?vue&type=template&id=7675414e&scoped=true&", function () {
      api.rerender('7675414e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/noticeList.vue"
export default component.exports